import React from 'react';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-navy-dark border-b-2 border-gold" data-id="element-249">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-3 text-sm md:text-base" data-id="element-250">
        <span className="text-white/90 font-medium" data-id="element-251">
          ⏰ Precio de Lanzamiento — Oferta por Tiempo Limitado
        </span>
        <span className="hidden sm:flex items-center gap-2 bg-gold/15 text-gold px-3 py-1 rounded-full text-xs font-semibold" data-id="element-252">
          <span className="relative flex h-2 w-2" data-id="element-253">
            <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 pulse-dot" data-id="element-254"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" data-id="element-255"></span>
          </span>
          Activo ahora
        </span>
      </div>
    </div>;
}